import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Course, Instructor } from "../../types/types";
export type CoursesDTO = Course & {
  enrolled?: boolean;
  Instructor: Instructor;
  _count: {
    students?: number;
  };
  startDate?: string;
  isLive?: boolean;
};

interface CoursesData {
  coursesData: {
    id: string;
    name: string;
    slug: string;
  }[];
}
interface CoursesResponse {
  data?: CoursesData;
  error?: ApiError;
}

export const GetAllCoursesList = async (): Promise<CoursesResponse> => {
  try {
    const response = await axios.get("/course/all-list");

    return { data: { coursesData: response.data } };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
